var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass:
            "col-xl-8 offset-xl-2 col-lg-10 offset-lg-1 col-md-12 col-sm-12 col-xs-12",
        },
        [
          _c(
            "div",
            {
              staticClass: "container small",
              staticStyle: { "margin-top": "30px" },
              attrs: { "data-test-id": "SigninView" },
            },
            [
              _c("div", { staticClass: "border-box" }, [
                _c("h3", { staticClass: "fg-color-blue" }, [
                  _vm._v("Your session expired"),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-warning",
                      attrs: {
                        href: `/organizations/sessions/new?returnUrl=${_vm.$route.params.returnUrl}`,
                      },
                    },
                    [_vm._v("Start a new session")]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }